import {FC, PropsWithChildren, useMemo} from "react";
import {useQueryResultContext} from "@constructor/components/features/queries/context";
import {getNestedValue} from "@/helpers/utils";
import {injectChildArray} from "@constructor/functions";

interface QueryArrayProps {
    field: string;
    key_field: string;
}

const QueryArray: FC<PropsWithChildren<QueryArrayProps>> = ({field, key_field, children}) => {
    const result = useQueryResultContext();

    if(!result?.result) {
        return null;
    }

    const value = getNestedValue(result.result, field);

    const data = useMemo(() => {
        if(!Array.isArray(value)) {
            return [value];
        }

        return value;
    }, [])

    return injectChildArray(data, children, key_field);
}

export default QueryArray;